import React, { useContext, useEffect, useState } from 'react'



import { useNavigate, useParams } from 'react-router'
import { Link } from 'react-router-dom'

import PageUrlGuid from '../component/pageUrlGuid'
import Seperator from '../component/seperator'
import { isUserBuyedWebinar, studentNumber, webinar, webinarFiles } from '../service/webinarsService'
import { checkIsCompleteInfo } from '../service/userService'
import { errorMessage, infoMessage, successMessage } from "../utils/toastMessage"
import { isEmptyUser } from "../utils/isEmpty"
import Modal from '../component/modal/modal';
import ReactPlayer from 'react-player';


//third party
import { useSelector, useDispatch } from 'react-redux'


const File = () => {
    const navigate = useNavigate()
    const user = useSelector((state) => state.user)
    const [getWebinar, setWebinar] = useState({})
    const [getIsUserRegistered, setIsUserRegistered] = useState(false)
    const [getTags, setTags] = useState([])
    const [getStudentNumber, setStudentNumber] = useState([])
    const [getModal, setModal] = useState(false)
    const [getVideoAdd, setVideoAdd] = useState("")
    const [getWebinarFiles, setWebinarFiles] = useState([])
    const slug = useParams().slug

    const handleGetWebinars = async (slug) => {
        try {
            const { status, data } = await webinar(slug);
            if (status === 200) {
                setWebinar(data.webinar)
                setTags(data.tags)
                document.getElementById("description").innerHTML = data.webinar.description
            }
        }
        catch (ex) {
            navigate("/notFound")
        }


    }


    const handleCopyToClipboard = (element) => {
        var el = document.querySelector(element).innerHTML
        navigator.clipboard.writeText(el);
        successMessage("لینک کپی شد")
    }

    const handleBuy = async () => {
        if (isEmptyUser(user.value)) {
            infoMessage("ابتدا وارد حساب کاربری خود شوید")
        }
        else {
            try {
                const { status, data } = await checkIsCompleteInfo(user.value.username);
                console.log(status);
                if (status === 200) {
                    navigate(`/buyWebinar/${getWebinar.slug}`)
                }

            }
            catch (ex) {
                infoMessage("ابتدا اطلاعات حساب کاربری خود را کامل کنید")
            }
        }
    }

    const handetCheckUserRegistered = async () => {

        try {
            const { status, data } = await isUserBuyedWebinar(user.value.username, slug);
            if (status === 200) {
                setIsUserRegistered(true)
            }
        }
        catch (ex) {
        }
        console.log(getIsUserRegistered);
    }


    const handleDownload = (url) => {

        if (getIsUserRegistered) {
            window.location.href = url
        }
        else {
            if (isEmptyUser(user.value)) {
                infoMessage("ابتدا وارد حساب کاربری خود شوید")
            }
            else {
                infoMessage("شما این وبینار را نخریده اید")
            }


        }
    }


    const handetGetWebinarFiles = async () => {
        try {
            const { status, data } = await webinarFiles(slug);
            if (status === 200) {
                setWebinarFiles(data.webinarFiles)
            }

        }
        catch (ex) {
        }
    }



    const handlePlayVideo = (add) => {
        if (getIsUserRegistered) {
            setModal(true)
            setVideoAdd(add)


        }
        else {
            if (isEmptyUser(user.value)) {
                infoMessage("ابتدا وارد حساب کاربری خود شوید")
            }
            else {
                infoMessage("شما فایل های این وبینار را نخریده اید")
            }
        }
    }

    const handleDisableRightClick = (event) => {
        event.preventDefault()
    }




    const handleGetStudentNumber = async () => {
        try {
            const { status, data } = await studentNumber(slug);
            if (status === 200) {
                setStudentNumber(data.buy)
            }
        }
        catch (ex) {
        }
    }




    useEffect(() => {
        handleGetWebinars(slug)
        handetCheckUserRegistered()
        handetGetWebinarFiles()
        handleGetStudentNumber()

        const disableRightClick = (event) => handleDisableRightClick(event)
        document.addEventListener('contextmenu', disableRightClick);
        return (() => {
            document.removeEventListener('contextmenu', disableRightClick)
        })
    }, [user.value])
    return (
        <>
            {
                getModal
                    ?
                    <Modal stateName={setModal}>
                        <ReactPlayer
                            // Disable download button
                            config={{ file: { attributes: { controlsList: 'nodownload' } } }}

                            // Disable right click
                            onContextMenu={e => e.preventDefault()}
                            url={getVideoAdd}
                            playing={true}
                            width="80%"
                            height="auto"
                            controls={true}
                            download={false}
                        />



                    </Modal>
                    : null
            }






            <PageUrlGuid>
                <Link to={"/"}>
                    صفحه اصلی
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <Link to={"/files"}>
                    فایل های وبینار ها
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h1>
                    {getWebinar.title}
                </h1>
            </PageUrlGuid>
            <div className='singleBlog'>
                    {getIsUserRegistered ? (
                        <button className='buy'>شما در این دوره ثبت نام کرده اید
                        </button>
                    ) : (

                        <button className='buy' onClick={handleBuy}>  ثبت نام در این دوره
                            <i className='fa fa-check'></i>
                        </button>
                    )}
                <div className='content-container'>
                    <div className='content'>
                        <img src={getWebinar.image} alt={getWebinar.title} />
                        <h2 className='title'>{getWebinar.title}</h2>
                        <h3 className='briefing'>{getWebinar.brifing}</h3>
                        <div className='description' id='description'></div>
                    </div>






                    <div className='files'>
                        <div className='title'>
                            <i className='fa fa-folder'></i>
                            <h2>فایل ها و ویدیو های دوره</h2>
                        </div>
                        <div className='files-content'>
                            {getWebinarFiles.map(webinarFile => (
                                <div key={webinarFile.id} className='file'>
                                    <span>{webinarFile.title}</span>
                                    {webinarFile.type !== "video" ?
                                        (
                                            <>
                                                <i className='fa fa-download' onClick={(e) => handleDownload(webinarFile.adderess)}></i>
                                            </>

                                        ) :
                                        (
                                            <i className='fa fa-play' onClick={(e) => handlePlayVideo(webinarFile.adderess)}></i>
                                        )}
                                </div>
                            ))}
                            {/* {console.log(getWebinarFiles)} */}
                        </div>




                    </div>
                    <div className='tags'>
                        <div className='title'>
                            <i className='fa fa-tags'></i>
                            <h2>برچسب ها</h2>
                        </div>
                        <div className='tags-content'>
                            {getTags.map(tag => (
                                <Link to={`/files?page=1&filter=id&search=${tag.title}&category=`} key={tag.id} className='tag'>{tag.title}</Link>
                            ))}
                        </div>
                    </div>
                    <div className='social-shortcut'>
                        <div className='social'>
                            <span className='title'>اشتراک گذاری :</span>
                            <div className='icons'>
                                {/* <Link className='link'>
                                    <img className='instagram-icon' src="http://localhost:8000/media/socialMedia/instagram.png" alt="" />
                                </Link> */}
                                <a className='link' href={`whatsapp://send?text=${window.location.href}`}>
                                    <img className='whatsapp-icon' src={`https://dl.newwebinar.ir/base/whatsapp.png`} alt="" />
                                </a>
                                <a className='link' href={`https://t.me/share/url?url=${window.location.href}`}>
                                    <img className='telegram-icon' src={`https://dl.newwebinar.ir/base/telegram.png`} alt="" />
                                </a>
                            </div>
                        </div>
                        <div className='shortcut' onClick={() => handleCopyToClipboard("#short-link")}>
                            <span>لینک کوتاه :</span>
                            <span className='short-link' id={'short-link'}>{`https://www.newwebinar.ir/s/2${getWebinar.id}`}</span>
                            <i className='fas fa-copy' ></i>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}


export default File